import { Zap } from 'lucide-react';
import { Logo } from './SiteHeader';

const QUICK_LINKS = [
  { label: 'About', href: '#about' },
  { label: 'Tracks', href: '#tracks' },
  { label: 'Schedule', href: '#schedule' },
  { label: 'FAQ', href: '#faq' },
  { label: 'Save your spot', href: '#rsvp' },
];

export function SiteFooter() {
  return (
    <footer className="border-t border-white/10 bg-[#1c0e26] text-white/70">
      <div className="container grid gap-10 py-14 md:grid-cols-[2fr_1fr_1fr]">
        <div className="space-y-4">
          <Logo className="text-white" />
          <p className="max-w-sm leading-relaxed">
            A Bitcoin &amp; Nostr hackathon for women, by women, in the green city in
            the sun. 14–15 November 2026, Nairobi, Kenya.
          </p>
          <a
            href="https://primal.net/search/%23SheSatsNairobi"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full border border-primary/40 bg-primary/10 px-4 py-2 text-sm font-semibold text-primary transition-colors hover:bg-primary/20"
          >
            <Zap className="size-4" fill="currentColor" aria-hidden />
            #SheSatsNairobi
          </a>
        </div>

        <nav className="space-y-3" aria-label="Footer">
          <p className="text-sm font-bold uppercase tracking-[0.25em] text-white/50">
            Explore
          </p>
          <ul className="space-y-2">
            {QUICK_LINKS.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  className="text-white/70 transition-colors hover:text-primary"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div className="space-y-3">
          <p className="text-sm font-bold uppercase tracking-[0.25em] text-white/50">
            Partners
          </p>
          <p className="leading-relaxed">
            Want to sponsor, mentor, or run a workshop? We’d love to hear from you —
            reach out on the hashtag above.
          </p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container flex flex-col items-center justify-between gap-3 py-6 text-sm sm:flex-row">
          <p>© 2026 SheSats Nairobi. Built by women, for women.</p>
          <p className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1">
            <span>Photos: Unsplash &amp; Pexels</span>
            <span aria-hidden>·</span>
            <a
              href="https://shakespeare.diy"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-primary transition-colors hover:text-white"
            >
              <Zap className="size-3.5" fill="currentColor" aria-hidden />
              Vibed with Shakespeare
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
